// import React, { lazy, Suspense } from 'react';
// import { Spin } from 'antd';

// const contentStyle = {
//   padding: 50,
//   borderRadius: 4,
// };


// const LoadingComponent = () => {
//   return <Spin tip="Loading" style={{
//     zIndex: 1110,
//     top: '50%',
//     left: '50%',
//     position: 'fixed',
//   }} />
// }; // Simple loading component

// const asyncRoute = (getComponent, props) => {
//   const LazyComponent = lazy(() => getComponent()); // Create a lazy-loaded component

//   // No need for explicit preloading within asyncRoute
//   // (Suspense handles loading when the component is rendered)

//   return (componentProps) => (
//     <Suspense fallback={<div style={{ padding: 20 }} />}>
//     {/* <Suspense fallback={<LoadingComponent />}> */}
//       <LazyComponent {...componentProps} {...props} />
//     </Suspense>
//   );
// };

// export default asyncRoute;
import React, { lazy, Suspense, useEffect } from 'react';
import { Spin } from 'antd';

const contentStyle = {
  padding: 50,
  borderRadius: 4,
};

// Simple Loading Component
const LoadingComponent = () => (
  <Spin 
    tip="Loading" 
    style={{
      zIndex: 1110,
      top: '50%',
      left: '50%',
      position: 'fixed',
      transform: 'translate(-50%, -50%)'  // To center the spinner
    }} 
  />
);

// Async route handling with lazy loading
const CHUNK_RELOAD_KEY = 'chunk-reload-attempted';
const CHUNK_ERROR_PATTERNS = [
  'Loading chunk',
  'ChunkLoadError',
  'Failed to fetch dynamically imported module',
  'Importing a module script failed',
];

const isChunkLoadError = (error) => {
  const message = error?.message || error?.toString?.() || '';
  return CHUNK_ERROR_PATTERNS.some((pattern) => message.includes(pattern));
};

const loadWithRecovery = async (getComponent) => {
  try {
    return await getComponent();
  } catch (error) {
    if (isChunkLoadError(error)) {
      const hasReloaded = sessionStorage.getItem(CHUNK_RELOAD_KEY) === '1';
      if (!hasReloaded) {
        sessionStorage.setItem(CHUNK_RELOAD_KEY, '1');
        window.location.reload();
        return new Promise(() => {});
      }
    }
    throw error;
  }
};

const asyncRoute = (getComponent, props) => {
  const LazyComponent = lazy(() => loadWithRecovery(getComponent)); // Lazy load the component

  return (componentProps) => {
    useEffect(() => {
      sessionStorage.removeItem(CHUNK_RELOAD_KEY);
    }, []);

    return (
      <Suspense fallback={<LoadingComponent />}>
        <LazyComponent {...componentProps} {...props} />
      </Suspense>
    );
  };
};

export default asyncRoute;
